function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ImmutableUnderReviewCompanyFormCheck from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewCompanyFormCheck';
import ImmutableUnderReviewCompanyFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewCompanyFormControl';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import sicCodeService from '@rd-web-markets/shared/dist/services/sic_codes/sic_code.service';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Form, Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import sicCodeSectionService from '@rd-web-markets/shared/dist/services/sic_codes/sic_code_section.service';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { DASHBOARD_TYPES } from '../constants';
import { Button, EditButton, DeleteButton, SaveButton, CancelButton } from '@rd-web-markets/shared/dist/util/buttons';
import { Table } from '@rd-web-markets/shared/dist/util';
import subsidiaryCompanyService from '@rd-web-markets/shared/dist/services/subsidiary_company.service';
import CenteredFormRow from './CenteredFormRow';
const CompanyMarketRelatedFields = _ref => {
  var _company$has_paye_ref, _company$has_paye_ref2, _company$has_paye_ref3, _company$has_made_cla, _company$has_made_cla2, _company$accounts_per, _company$accounts_per2, _company$business_uni, _company$business_uni2, _company$has_subsidia, _company$has_subsidia2, _company$requires_sep, _company$requires_sep2, _company$has_subsidia3, _company$has_subsidia4;
  let {
    company,
    handleChange,
    setCompany
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const [sicCodes, setSicCodes] = useState([]);
  const [sicCodeSections, setSicCodeSections] = useState([]);
  const [subsidiaryCompanies, setSubsidiaryCompanies] = useState(null);
  const [subsidiaryCompanyName, setSubsidiaryCompanyName] = useState('');
  const [subsidiaryCompanyUtr, setSubsidiaryCompanyUtr] = useState('');
  const [newSubsidiaryCompany, setNewSubsidiaryCompany] = useState({});
  const [editingSubsidiaryId, setEditingSubsidiaryId] = useState(null);
  const [editingFormData, setEditingFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [params, setParams] = useState();
  const updateSubsidiaryCompany = subsidiaryCompanyService.useUpdateSubsidiaryCompany(company.id);
  const sicCodeOptions = sicCodes.map(s => ({
    value: s.id,
    label: "(".concat(s.number, ") ").concat(s.title),
    sic_code_section_id: s.sic_code_section_id
  }));
  const sicCodeSectionOptions = sicCodeSections.map(s => ({
    value: s.id,
    label: s.name
  }));
  const dashboardTypeOptions = DASHBOARD_TYPES.map(type => ({
    value: type,
    label: t(type)
  }));
  const getSicCodes = useErrorHandling(useCallback(async () => {
    const response = await sicCodeService.get(params);
    setSicCodes(response.sic_codes);
  }));
  const getSicCodeSections = useErrorHandling(useCallback(async () => {
    const response = await sicCodeSectionService.get();
    setSicCodeSections(response.sic_code_sections);
  }, [setSicCodeSections]));
  useEffect(() => {
    getSicCodes();
    if (company.id) {
      const getSubsidiaryCompanies = async () => {
        const subsidiaryCompanies = await subsidiaryCompanyService.all(company.id);
        setSubsidiaryCompanies(subsidiaryCompanies);
      };
      getSubsidiaryCompanies();
    }
  }, [history, params, company.id]);
  useEffect(() => {
    getSicCodeSections();
  }, []);
  const handleSicCodeDropdownChange = e => {
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      sic_code_id: e.value,
      sic_code_section: e.sic_code_section_id
    }));
  };
  const handleSicCodeSectionDropdownChange = e => {
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      sic_code_section: e.value
    }));
    setParams("by_section=".concat(e.value));
  };
  const handleDashboardTypeDropdownChange = e => {
    setCompany(_objectSpread(_objectSpread({}, company), {}, {
      dashboard_type: e.value
    }));
  };
  const handleNewSubsidiaryCompanyChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setNewSubsidiaryCompany(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleEditingFormDataChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setEditingFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const createSubsidiaryCompany = async () => {
    const response = await subsidiaryCompanyService.create(company.id, newSubsidiaryCompany);
    setSubsidiaryCompanies([...subsidiaryCompanies, response]);
    setNewSubsidiaryCompany({});
  };
  const handleEditStart = (index, subsidiary) => {
    var _subsidiary$sic_code$, _subsidiary$sic_code;
    setEditingSubsidiaryId(subsidiary.id);
    setEditingFormData(_objectSpread(_objectSpread({}, subsidiary), {}, {
      sic_code_section: (_subsidiary$sic_code$ = (_subsidiary$sic_code = subsidiary.sic_code) === null || _subsidiary$sic_code === void 0 || (_subsidiary$sic_code = _subsidiary$sic_code.sic_code_section) === null || _subsidiary$sic_code === void 0 ? void 0 : _subsidiary$sic_code.id) !== null && _subsidiary$sic_code$ !== void 0 ? _subsidiary$sic_code$ : subsidiary.sic_code_section
    }));
  };
  const handleEditCancel = () => {
    setEditingSubsidiaryId(null);
    setEditingFormData({});
  };
  const handleEditSave = async () => {
    setSaving(true);
    const updatedSubsidiary = await updateSubsidiaryCompany(_objectSpread({}, editingFormData));
    setSubsidiaryCompanies(prev => prev.map(s => s.id === updatedSubsidiary.id ? updatedSubsidiary : s));
    setEditingSubsidiaryId(null);
    setEditingFormData({});
    setSaving(false);
  };
  const removeSubsidiaryCompany = async subsidiary => {
    if (!window.confirm('Are you sure you want to delete this subsidiary company?')) return;
    await subsidiaryCompanyService.destroy(company.id, subsidiary.id);
    setSubsidiaryCompanies(prev => prev.filter(sc => sc.id !== subsidiary.id));
    setSubsidiaryCompanyName('');
    setSubsidiaryCompanyUtr('');
  };
  const handleNewSubsidiarySicCodeDropdownChange = e => {
    setNewSubsidiaryCompany(prev => _objectSpread(_objectSpread({}, prev), {}, {
      sic_code_id: e.value,
      sic_code_section: e.sic_code_section_id
    }));
  };
  const handleNewSubsidiarySicSectionDropdownChange = e => {
    setNewSubsidiaryCompany(prev => _objectSpread(_objectSpread({}, prev), {}, {
      sic_code_section: e.value
    }));
    setParams("by_section=".concat(e.value));
  };
  const handleEditSicCodeDropdownChange = e => {
    setEditingFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      sic_code_id: e.value,
      sic_code_section: e.sic_code_section_id
    }));
  };
  const handleEditSicSectionDropdownChange = e => {
    setEditingFormData(prev => _objectSpread(_objectSpread({}, prev), {}, {
      sic_code_section: e.value
    }));
    setParams("by_section=".concat(e.value));
  };
  const handleImageUpload = async event => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(',')[1];
        setCompany(_objectSpread(_objectSpread({}, company), {}, {
          image_data: base64String
        }));
      };
      reader.readAsDataURL(file);
    }
  };
  const subsidiaryTableHeaders = [{
    text: 'Subsidiary Name'
  }, {
    text: 'Company Number'
  }, {
    text: 'UTR'
  }, {
    text: 'VAT Number'
  }, {
    text: 'Has Paye Ref Number'
  }, {
    text: 'PAYE Number'
  }, {
    text: 'SIC Code Section'
  }, {
    text: 'Industry/Sector'
  }, {
    text: ''
  }];
  const subsidiaryTableRows = useMemo(() => {
    if (!subsidiaryCompanies) return [];
    return subsidiaryCompanies.map((subsidiary, index) => {
      const isEditing = editingSubsidiaryId === subsidiary.id;
      const isSaving = saving && isEditing;
      const columns = isEditing ? [/*#__PURE__*/React.createElement(Form.Control, {
        size: "sm",
        name: "name",
        "data-testid": "edit-subsidiary-name",
        value: editingFormData.name || '',
        onChange: handleEditingFormDataChange
      }), /*#__PURE__*/React.createElement(Form.Control, {
        size: "sm",
        name: "number",
        "data-testid": "edit-subsidiary-number",
        value: editingFormData.number || '',
        onChange: handleEditingFormDataChange
      }), /*#__PURE__*/React.createElement(Form.Control, {
        size: "sm",
        name: "utr",
        "data-testid": "edit-subsidiary-utr",
        value: editingFormData.utr || '',
        onChange: handleEditingFormDataChange
      }), /*#__PURE__*/React.createElement(Form.Control, {
        size: "sm",
        name: "vat_number",
        "data-testid": "edit-subsidiary-vat-number",
        value: editingFormData.vat_number || '',
        onChange: handleEditingFormDataChange
      }), /*#__PURE__*/React.createElement(Form.Check, {
        name: "has_paye_ref_number",
        type: "checkbox",
        "data-testid": "edit-subsidiary-has-paye-ref-number",
        checked: editingFormData.has_paye_ref_number || false,
        onChange: handleEditingFormDataChange
      }), /*#__PURE__*/React.createElement(Form.Control, {
        size: "sm",
        name: "paye_ref_number",
        "data-testid": "edit-subsidiary-paye-ref-number",
        value: editingFormData.paye_ref_number || '',
        onChange: handleEditingFormDataChange
      }), /*#__PURE__*/React.createElement("div", {
        "data-testid": "edit-subsidiary-sic-section"
      }, /*#__PURE__*/React.createElement(Select, {
        value: sicCodeSectionOptions.find(o => o.value === editingFormData.sic_code_section),
        onChange: handleEditSicSectionDropdownChange,
        options: sicCodeSectionOptions,
        styles: {
          control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
            borderColor: '#80bbdc'
          })
        }
      })), /*#__PURE__*/React.createElement("div", {
        "data-testid": "edit-subsidiary-sic-code"
      }, /*#__PURE__*/React.createElement(Select, {
        value: sicCodeOptions.find(o => o.value === editingFormData.sic_code_id),
        onChange: handleEditSicCodeDropdownChange,
        options: sicCodeOptions,
        styles: {
          control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
            borderColor: '#80bbdc'
          })
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, /*#__PURE__*/React.createElement(SaveButton, {
        size: "sm",
        onClick: handleEditSave,
        disabled: isSaving,
        text: isSaving ? t('saving') : t('save')
      }), /*#__PURE__*/React.createElement(CancelButton, {
        size: "sm",
        onClick: handleEditCancel,
        disabled: isSaving
      }))] : [subsidiary.name, subsidiary.number, subsidiary.utr, subsidiary.vat_number, subsidiary.has_paye_ref_number ? 'Yes' : 'No', subsidiary.paye_ref_number, subsidiary.sic_code ? subsidiary.sic_code.sic_code_section.name : '', subsidiary.sic_code ? subsidiary.sic_code.title : '', /*#__PURE__*/React.createElement("div", {
        className: "d-flex justify-content-end gap-2"
      }, /*#__PURE__*/React.createElement(EditButton, {
        size: "sm",
        onClick: () => handleEditStart(index, subsidiary)
      }), /*#__PURE__*/React.createElement(DeleteButton, {
        size: "sm",
        onClick: () => removeSubsidiaryCompany(subsidiary)
      }))];
      return {
        key: "subsidiary-".concat(subsidiary.id, "-").concat(isEditing ? 'edit' : 'view'),
        data: {
          object: _objectSpread({}, subsidiary)
        },
        columns
      };
    });
  }, [subsidiaryCompanies, editingSubsidiaryId, editingFormData, saving, sicCodeOptions, sicCodeSectionOptions]);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Company Name*"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: company.name,
    name: "name",
    disabled: user.account_type !== 'admin',
    onChange: handleChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Company Abbreviated Name"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: company.abbreviated_name || '',
    name: "abbreviated_name",
    onChange: handleChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "VAT Number"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: company.vat_number || '',
    name: "vat_number",
    onChange: handleChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Has Paye Reference Number?"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "Yes",
    value: "true",
    checked: ((_company$has_paye_ref = company.has_paye_ref_number) === null || _company$has_paye_ref === void 0 ? void 0 : _company$has_paye_ref.toString()) === 'true',
    name: "has_paye_ref_number",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "No",
    value: "false",
    checked: ((_company$has_paye_ref2 = company.has_paye_ref_number) === null || _company$has_paye_ref2 === void 0 ? void 0 : _company$has_paye_ref2.toString()) === 'false',
    name: "has_paye_ref_number",
    onChange: handleChange,
    size: "md"
  })), ((_company$has_paye_ref3 = company.has_paye_ref_number) === null || _company$has_paye_ref3 === void 0 ? void 0 : _company$has_paye_ref3.toString()) === 'true' && /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Paye Ref Number"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: company.paye_ref_number || '',
    name: "paye_ref_number",
    onChange: handleChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Claimed R&D tax credits before?*"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "Yes",
    value: "true",
    checked: ((_company$has_made_cla = company.has_made_claims_before) === null || _company$has_made_cla === void 0 ? void 0 : _company$has_made_cla.toString()) === 'true',
    name: "has_made_claims_before",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "No",
    value: "false",
    checked: ((_company$has_made_cla2 = company.has_made_claims_before) === null || _company$has_made_cla2 === void 0 ? void 0 : _company$has_made_cla2.toString()) === 'false',
    name: "has_made_claims_before",
    onChange: handleChange,
    size: "md"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Has the company accounting period changed?"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "Yes",
    value: "true",
    disabled: user.account_type !== 'admin',
    checked: ((_company$accounts_per = company.accounts_period_changed) === null || _company$accounts_per === void 0 ? void 0 : _company$accounts_per.toString()) === 'true',
    name: "accounts_period_changed",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "No",
    value: "false",
    checked: ((_company$accounts_per2 = company.accounts_period_changed) === null || _company$accounts_per2 === void 0 ? void 0 : _company$accounts_per2.toString()) === 'false',
    name: "accounts_period_changed",
    onChange: handleChange,
    size: "md"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Business Unit Required"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "Yes",
    value: "true",
    disabled: user.account_type !== 'admin',
    checked: ((_company$business_uni = company.business_unit_required) === null || _company$business_uni === void 0 ? void 0 : _company$business_uni.toString()) === 'true',
    name: "business_unit_required",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "No",
    value: "false",
    checked: ((_company$business_uni2 = company.business_unit_required) === null || _company$business_uni2 === void 0 ? void 0 : _company$business_uni2.toString()) === 'false',
    name: "business_unit_required",
    onChange: handleChange,
    size: "md"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Has Subsidiary Companies?"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "Yes",
    value: "true",
    disabled: user.account_type !== 'admin',
    checked: ((_company$has_subsidia = company.has_subsidiary_companies) === null || _company$has_subsidia === void 0 ? void 0 : _company$has_subsidia.toString()) === 'true',
    name: "has_subsidiary_companies",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "No",
    value: "false",
    checked: ((_company$has_subsidia2 = company.has_subsidiary_companies) === null || _company$has_subsidia2 === void 0 ? void 0 : _company$has_subsidia2.toString()) === 'false',
    name: "has_subsidiary_companies",
    onChange: handleChange,
    size: "md"
  })), company.has_subsidiary_companies && /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Requires separate AIF submission?"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "Yes",
    value: "true",
    disabled: user.account_type !== 'admin',
    checked: ((_company$requires_sep = company.requires_separate_aif_submission) === null || _company$requires_sep === void 0 ? void 0 : _company$requires_sep.toString()) === 'true',
    name: "requires_separate_aif_submission",
    onChange: handleChange,
    size: "md"
  }), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormCheck, {
    inline: true,
    type: "radio",
    label: "No",
    value: "false",
    checked: ((_company$requires_sep2 = company.requires_separate_aif_submission) === null || _company$requires_sep2 === void 0 ? void 0 : _company$requires_sep2.toString()) === 'false',
    name: "requires_separate_aif_submission",
    onChange: handleChange,
    size: "md"
  })), ((_company$has_subsidia3 = company.has_subsidiary_companies) === null || _company$has_subsidia3 === void 0 ? void 0 : _company$has_subsidia3.toString()) === 'true' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: "m-4"
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    className: "mt-4"
  }, "Enter new Subsidiary details")), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Subsidiary Name"), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: newSubsidiaryCompany.name || '',
    name: "name",
    "data-testid": "new-subsidiary-name",
    onChange: handleNewSubsidiaryCompanyChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Company Number"), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: newSubsidiaryCompany.number || '',
    name: "number",
    "data-testid": "new-subsidiary-number",
    onChange: handleNewSubsidiaryCompanyChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Form.Label, null, "UTR"), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: newSubsidiaryCompany.utr || '',
    name: "utr",
    "data-testid": "new-subsidiary-utr",
    onChange: handleNewSubsidiaryCompanyChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Form.Label, null, "VAT Number"), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: newSubsidiaryCompany.vat_number || '',
    name: "vat_number",
    "data-testid": "new-subsidiary-vat-number",
    onChange: handleNewSubsidiaryCompanyChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 1,
    className: "d-flex flex-column align-items-center justify-content-center text-center"
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Has PAYE Ref Number"), /*#__PURE__*/React.createElement(Form.Check, {
    name: "has_paye_ref_number",
    type: "checkbox",
    "data-testid": "new-subsidiary-has-paye-ref-number",
    checked: newSubsidiaryCompany.has_paye_ref_number || false,
    onChange: handleNewSubsidiaryCompanyChange
  })), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, /*#__PURE__*/React.createElement(Form.Label, null, "Paye Ref Number"), /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: newSubsidiaryCompany.paye_ref_number || '',
    name: "paye_ref_number",
    "data-testid": "new-subsidiary-paye-ref-number",
    onChange: handleNewSubsidiaryCompanyChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, "SIC Code Section", /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "right",
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, "\"In case you don't know \"SIC Code Section\", find exact SIC code using field \"Industry/Sector (SIC)\"\"")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 ms-1",
    style: {
      color: '#0078b9'
    }
  }, "info"))), /*#__PURE__*/React.createElement("div", {
    "data-testid": "new-subsidiary-sic-section"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: Select,
    value: sicCodeSectionOptions.find(o => o.value === newSubsidiaryCompany.sic_code_section),
    onChange: handleNewSubsidiarySicSectionDropdownChange,
    options: sicCodeSectionOptions,
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: '#80bbdc'
      })
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, "Industry/Sector (SIC)"), /*#__PURE__*/React.createElement("div", {
    "data-testid": "new-subsidiary-sic-code"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: Select,
    value: sicCodeOptions.find(o => o.value === newSubsidiaryCompany.sic_code_id),
    onChange: handleNewSubsidiarySicCodeDropdownChange,
    options: sicCodeOptions,
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: '#80bbdc'
      })
    }
  }))), /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md",
    className: "mt-3"
  }), /*#__PURE__*/React.createElement(Button, {
    className: "ms-4 mt-1",
    onClick: createSubsidiaryCompany,
    size: "md"
  }, "+ Add New Subsidiary"))), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, "Subsidiary Listing"), /*#__PURE__*/React.createElement(Table, {
    headers: subsidiaryTableHeaders,
    rows: subsidiaryTableRows,
    showControls: false
  }))), /*#__PURE__*/React.createElement("hr", {
    className: "m-4"
  })), ((_company$has_subsidia4 = company.has_subsidiary_companies) === null || _company$has_subsidia4 === void 0 ? void 0 : _company$has_subsidia4.toString()) === 'false' && /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Company Unique Tax Reference (UTR)"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    value: company.utr || '',
    name: "utr",
    onChange: handleChange,
    size: "md",
    type: "text"
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "SIC Code Section", /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "right",
      overlay: /*#__PURE__*/React.createElement(Tooltip, null, "\"In case you don't know \"SIC Code Section\", find exact SIC code using field \"Industry/Sector (SIC)\"\"")
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons md-18 ms-1",
      style: {
        color: '#0078b9'
      }
    }, "info")))
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: Select,
    value: sicCodeSectionOptions.find(o => o.value === company.sic_code_section),
    onChange: handleSicCodeSectionDropdownChange,
    options: sicCodeSectionOptions,
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: '#80bbdc'
      })
    }
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Industry/Sector (SIC)"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: Select,
    value: sicCodeOptions.find(o => o.value === company.sic_code_id),
    onChange: handleSicCodeDropdownChange,
    options: sicCodeOptions,
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: '#80bbdc'
      })
    }
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: "Dashboard Type"
  }, /*#__PURE__*/React.createElement(ImmutableUnderReviewCompanyFormControl, {
    as: Select,
    value: dashboardTypeOptions.find(o => o.value === company.dashboard_type),
    onChange: handleDashboardTypeDropdownChange,
    options: dashboardTypeOptions,
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: '#80bbdc'
      })
    }
  })), /*#__PURE__*/React.createElement(CenteredFormRow, {
    label: t('company_logo')
  }, /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: "image/*",
    onChange: handleImageUpload,
    className: "form-control"
  }), company.image_data && /*#__PURE__*/React.createElement("img", {
    src: "data:image/png;base64,".concat(company.image_data),
    alt: "Template Preview",
    style: {
      maxWidth: '200px',
      marginTop: '10px'
    }
  }))));
};
export default CompanyMarketRelatedFields;